import type { JSX } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { RefereeConfirmFormProps } from '../types/referee-app.types';
import { RelationshipSelect } from './RelationshipSelect';
import { RefereeQuestionsSection } from './RefereeQuestionsSection';
import { useRefereeConfirmForm } from '../hooks/useRefereeConfirmForm';

function TextField({
  id,
  label,
  placeholder,
  type,
  value,
  onChange,
  disabled,
}: {
  id: string;
  label: string;
  placeholder: string;
  type: string;
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}): JSX.Element {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}

export function RefereeConfirmForm(props: RefereeConfirmFormProps): JSX.Element {
  const form = useRefereeConfirmForm(props);

  return (
    <form onSubmit={form.handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label>Your relationship to the candidate</Label>
        <RelationshipSelect
          value={form.relationship}
          onChange={form.setRelationship}
          disabled={form.isPending}
        />
      </div>
      <TextField
        id="confirm-phone"
        label="Phone number"
        placeholder="Enter your phone number"
        type="tel"
        value={form.phone}
        onChange={form.setPhone}
        disabled={form.isPending}
      />
      <TextField
        id="confirm-job-title"
        label="Enter the title you had while supervising the candidate"
        placeholder="Your job title"
        type="text"
        value={form.jobTitle}
        onChange={form.setJobTitle}
        disabled={form.isPending}
      />
      {props.questions.length > 0 && (
        <RefereeQuestionsSection
          questions={props.questions}
          answers={form.answers}
          onAnswerChange={form.onAnswerChange}
          errors={form.answerErrors}
        />
      )}
      <Button type="submit" disabled={form.isPending}>
        {form.isPending ? 'Submitting...' : 'Submit'}
      </Button>
    </form>
  );
}
